import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SprobotconfigService {
  public settings: any;
  public appSetting: any;
  private http: HttpClient;

  constructor(private readonly httpHandler: HttpBackend) {
    this.http = new HttpClient(httpHandler);
  }

  init(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      fetch('/assets/appsettings.json')
        .then((response) => response.json())
        .then(async (appSetting) => {
          this.appSetting = appSetting;
          
          this.http.get(this.appSetting.ConfigUrl + '/getwfeconfig?environment=' + this.appSetting.Environment).pipe(map(res => res))
            .subscribe(value => {
              this.settings = value;
              resolve(true);
            },
              (error) => {
                reject(error);
              });
        });
    });
  }

  getSetting(key: string): any {
    let result = this.settings.filter((s: any) => s.propertyName == key);
    return result.length == 0 ? undefined : result[0];
  }
}
